export const initTranslations = {
  ar: { initialLoadingText: 'جاري التحميل يرجى الانتظار', deposit: 'إيداع', withdraw: 'سحب' },
  bg: { initialLoadingText: 'Зареждане, моля изчакайте', deposit: 'Депозит', withdraw: 'Теглене' },
  cs: { initialLoadingText: 'Načítání prosím čekejte', deposit: 'Vklad', withdraw: 'Výběr' },
  da: {
    initialLoadingText: 'Indlæser vent venligst',
    deposit: 'Indbetaling',
    withdraw: 'Udbetaling',
  },
  de: { initialLoadingText: 'Laden, bitte warten', deposit: 'Einzahlung', withdraw: 'Auszahlung' },
  el: {
    initialLoadingText: 'Φορτώνει... παρακαλώ περιμένετε',
    deposit: 'Κατάθεση',
    withdraw: 'Ανάληψη',
  },
  en: { initialLoadingText: 'Loading... Please Wait', deposit: 'Deposit', withdraw: 'Withdraw' },
  es: {
    initialLoadingText: 'Cargando... por favor espere',
    deposit: 'Depósito',
    withdraw: 'Retirada',
  },
  et: {
    initialLoadingText: 'Laadimine... Palun oodake',
    deposit: 'Sissemakse',
    withdraw: 'Väljamakse',
  },
  fi: { initialLoadingText: 'Ladataan, odota', deposit: 'Talletus', withdraw: 'Nosto' },
  fr: {
    initialLoadingText: 'Chargement, veuillez patienter',
    deposit: 'Dépôt',
    withdraw: 'Retrait',
  },
  he: { initialLoadingText: 'בטעינה אנא המתן', deposit: 'הפקדה', withdraw: 'משיכה' },
  hi: {
    initialLoadingText: 'लोड हो रहा है कृपया प्रतीक्षा करें',
    deposit: 'जमा',
    withdraw: 'निकासी',
  },
  hu: {
    initialLoadingText: 'Betöltés... kérem várjon',
    deposit: 'Befizetés',
    withdraw: 'Kifizetés',
  },
  hy: {
    initialLoadingText: 'Բեռնվում է, խնդրում ենք սպասել',
    deposit: 'Ավանդ',
    withdraw: 'Հանում',
  },
  id: { initialLoadingText: 'Sedang memuat... Harap tunggu', deposit: 'Setor', withdraw: 'Tarik' },
  it: {
    initialLoadingText: 'Attendere... il caricamento prego',
    deposit: 'Deposito',
    withdraw: 'Prelievo',
  },
  jp: {
    initialLoadingText: '読み込み中です。しばらくお待ちください',
    deposit: '入金',
    withdraw: '出金',
  },
  ka: { initialLoadingText: 'Იტვირთება გთხოვთ მოიცადოთ', deposit: 'შენატანი', withdraw: 'გატანა' },
  kh: {
    initialLoadingText: 'កំពុងផ្ទុក... សូមរង់ចាំ',
    deposit: 'ដាក់ប្រាក់',
    withdraw: 'ដកប្រាក់',
  },
  ko: { initialLoadingText: '로딩 중 기다려주세요', deposit: '입금', withdraw: '출금' },
  lt: {
    initialLoadingText: 'Kraunasi... Prašome palaukti',
    deposit: 'Įnešimas',
    withdraw: 'Išėmimas',
  },
  lv: {
    initialLoadingText: 'Notiek ielāde... Lūdzu, uzgaidiet',
    deposit: 'Iemaksa',
    withdraw: 'Izmaksa',
  },
  ms: { initialLoadingText: 'Muat turun sila tunggu', deposit: 'Deposit', withdraw: 'Pengeluaran' },
  nl: { initialLoadingText: 'Laden even geduld aub', deposit: 'Storting', withdraw: 'Opname' },
  no: { initialLoadingText: 'Laster Vennligst vent', deposit: 'Innskudd', withdraw: 'Uttak' },
  pl: {
    initialLoadingText: 'Trwa ładowanie, proszę czekać',
    deposit: 'Wpłata',
    withdraw: 'Wypłata',
  },
  pt: {
    initialLoadingText: 'Carregando, por favor espere',
    deposit: 'Depósito',
    withdraw: 'Levantamento',
  },
  ru: {
    initialLoadingText: 'Загрузка, пожалуйста подождите',
    deposit: 'Депозит',
    withdraw: 'Вывод',
  },
  sk: { initialLoadingText: 'Načitáva sa, prosím čakajte', deposit: 'Vklad', withdraw: 'Výber' },
  sl: { initialLoadingText: 'Nalagam. Prosimo počakajte', deposit: 'Depozit', withdraw: 'Dvig' },
  sq: {
    initialLoadingText: 'Duke u ngarkuar, ju lutem prisni',
    deposit: 'Depozitë',
    withdraw: 'Tërheqje',
  },
  sr: { initialLoadingText: 'Учитавање сачекајте', deposit: 'Депозит', withdraw: 'Исплата' },
  sv: { initialLoadingText: 'Laddar... Var god vänta', deposit: 'Insättning', withdraw: 'Uttag' },
  ta: {
    initialLoadingText: 'பதிவேறுகிறது, காத்திருக்கவும்',
    deposit: 'வைப்பு',
    withdraw: 'திரும்பப் பெறுதல்',
  },
  th: {
    initialLoadingText: 'กำลังโหลด... กรุณารอสักครู่',
    deposit: 'ฝากเงิน',
    withdraw: 'ถอนเงิน',
  },
  tl: {
    initialLoadingText: 'Naglo-load... Mangyaring maghintay',
    deposit: 'Deposito',
    withdraw: 'Mag-withdraw',
  },
  tr: {
    initialLoadingText: 'Yükleniyor.. Lütfen bekleyiniz',
    deposit: 'Para Yatırma',
    withdraw: 'Para Çekme',
  },
  uk: {
    initialLoadingText: 'Завантаження, зачекайте будь-ласка',
    deposit: 'Депозит',
    withdraw: 'Виведення',
  },
  vi: { initialLoadingText: 'Tải vui lòng đợi', deposit: 'Nạp tiền', withdraw: 'Rút tiền' },
  zh_CHS: { initialLoadingText: '加载请稍候', deposit: '存款', withdraw: '取款' },
  zh_CHT: { initialLoadingText: '加载请稍候', deposit: '存款', withdraw: '提款' },
};
